/**
* @file 战队-加入战队
* @author 余凯
*/

import React from 'react'
import { Table, Button } from 'antd'
import { connect } from 'react-redux'
import { getTeamList, getGameList } from '@/redux/teamRedux'
import HomeInfo from '../home/info'
import Actions from '@/apis/team'
import './index.less'

@connect(
  state => state.teamReducer,
  { getTeamList, getGameList }
)
class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      id: null,
      tabActive: null,
      sort: 1,
      page_index: 1,
      data: []
    }
  }

  async componentDidMount() {
    if (this.props.game) {
      this.setState({
        tabActive: this.props.game
      })

      const params = {
        game_id: this.props.game,
        sort: 1,
        page_size: 10,
        page_index: 1
      }

      this.props.getTeamList(params)
    } else {
      // setTimeout(() => {
      //   this.getGameList()
      // }, 500)
    }
  }

  getGameList = async (id = this.props.game) => {
    const params = {
      game_id: id,
      page_index: this.state.page_index,
      sort: this.state.sort
    }
    const res = await Actions.teams(params)
    this.setState({
      data: res.data.list,
    })
  }

  handleGoList = () => {
    this.setState({
      step: 1
    })
  }

  changeTabs = (v) => {
    this.setState({
      tabActive: v
    })
    this.getGameList(v)
  }

  handleSort = (v) => {
    this.setState({
      sort: v,
      page_index: 1
    })

    const params = {
      game_id: this.props.game,
      sort: v,
      page_size: 10,
      page_index: 1
    }

    this.props.getTeamList(params)
  }

  renderTableTitle = () => {
    const { tabActive } = this.state
    return (
      <div className="table_title">
        <Button type="primary"
          onClick={() => this.handleSort(1)}>
          热度排序
        </Button>
        <Button type="primary"

          onClick={() => this.handleSort(2)}>
          最新排序
        </Button>
      </div>
    )
  }

  handleGoTeam = id => {
    const { tabActive } = this.state
    this.setState({
      id,
      step: 2
    })
  }

  columns = () => [
    {
      title: '名次',
      dataIndex: 'team_rank',
      render: (text, record, index) => ((this.state.page_index - 1) * 10  + index + 1),
      width: 50,
    },
    {
      title: '战队名称',
      dataIndex: 'team_name',
      width: 150,
    },
    {
      title: '队长名称',
      dataIndex: 'teamer_name',
      width: 150,
    },
    {
      title: '人数/上限',
      dataIndex: 'max_member_count',
      render: (action, record) => (record.member_count + '/' + record.max_member_count)
    },
    {
      title: '等级',
      dataIndex: 'team_level',
    },
    {
      title: '城市',
      dataIndex: 'city_name',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'action',
      render: (action, record) => (
        <Button disabled={action}
          onClick={() => this.handleGoTeam(record.game_team_id)}
          type="primary"
          shape="round"
          size="small">
          进入
        </Button>
      )
    },
  ];

  handleChangePagination = (page, pageSize) => {
    const params = {
      game_id: this.props.game,
      sort: this.state.sort,
      page_size: 10,
      page_index: page
    }
    this.setState({
      page_index: page
    })
    this.props.getTeamList(params)
  }

  render() {
    const { step, id } = this.state
    return (
      <div className="join_team" id="join_team">
        {
          step === 2 ? <HomeInfo otherTeam={true} id={id} onGoList={this.handleGoList} /> : (
            <Table
              rowKey="game_team_id"
              title={this.renderTableTitle}
              size="small"
              columns={this.columns()}
              dataSource={this.props.teamList && this.props.teamList.list}
              pagination={{ current: this.state.page_index, onChange: this.handleChangePagination, pageSize: 10, total: this.props.teamList && this.props.teamList.totalNumber }}
            />
          )
        }

      </div>
    );
  }
}

export default Results;
